export enum ProductionBundles {
  // External Customer-Facing Platform
  SolutionsPlatform = 'solutions-platform',
  // Internal Tools Platform
  CanaryCommand = 'canary-command',
  // PDF Templates
  PdfTemplates = 'pdf-templates'
}

export enum ProductionBundleSubdomains {
  // External Customer-Facing Platform
  SolutionsPlatform = 'solutions',
  // Internal Tools Platform
  CanaryCommand = 'canary'
}
